/**
 * Fetch with timeout wrapper
 * Prevents requests from hanging indefinitely
 * @param {string} url - The URL to fetch
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @param {number} timeout - Timeout in milliseconds (default: 30 seconds)
 * @returns {Promise} - Fetch promise that rejects on timeout
 */
export const fetchWithTimeout = (url, options = {}, timeout = 30000) => {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Request timeout - Server took too long to respond')), timeout)
    )
  ]);
};
